<div class="row mt-5">
    <div class="title">Cuisine Preference</div>
</div>

<div class="row mt-4">
    <div class="col-sm">
        <div class="mealTitle">Default Cuisine</div>
        <div class="row mt-3" *ngIf="this.allPrefer.cuisine != undefined">
            <div class="col-md-6 colDiv1 activeCol1 mt-2" *ngFor='let cusin of this.allPrefer.cuisine.defaultCuisines;let i=index'>
                <div class="curisieSubTitle">{{cusin}}</div>
                <div class="crossMain" >
                <div class="cross" (click)="removePreference(i,1)">X</div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-2">
            <div class="cross1Main" (click)="addPreference(1)">
                <div class="cross2Sub">
                <div class="cross1">+</div>
                </div>
                </div>
        </div>
        <div class="flex mt-4" *ngIf="isAddValue == 1">
            <input type="text" class="form-control textField textContent"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
       
    </div>

    <div class="col-sm ml-1">
        <div class="mealTitle">Other Liked Cuisine</div>
        <div class="row mt-3" *ngIf="this.allPrefer.cuisine != undefined">
            <div class="col-md-6 colDiv1 activeCol1 mt-4" *ngFor='let likesCuisin of allPrefer.cuisine.likedCuisines;let i=index'>
                <div class="curisieSubTitle">{{likesCuisin}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,2)">X</div>
                </div>
            </div>

            
           
            
        </div>
        <div class="col-md-12 mt-2">
            <div class="cross1Main" (click)="addPreference(2)">
                <div class="cross2Sub">
                <div class="cross1">+</div>
                </div>
                </div>
        </div>

        <div class="flex mt-4" *ngIf="isAddValue == 2">
            <input type="text" class="form-control textField textContent"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>

    </div>
    <div class="col-sm">
        <div class="mealTitle">Disliked Cuisine</div>
        <div class="row flex mt-3" *ngIf="this.allPrefer.cuisine != undefined">
            <div class="col-4 colDivRed mt-2" *ngFor='let dislike of allPrefer.cuisine.dislikedCuisines;let i=index;'>
                <div class="curisieSubTitleRed">{{dislike}}</div>
                <div class="crossMain">
                <div class="crossRed" (click)="removePreference(i,3)">X</div>
                </div>
            </div>
        </div>
           
            <div class="col-12 mt-3">
                <div class="cross1Main" (click)="addPreference(3)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
           
        
        <div class="flex mt-4" *ngIf="isAddValue == 3">
            <input type="text" class="form-control textField textContent"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
       
    </div>

    <div class="col-md-12 mt-4">
        <div class="mealTitle">Food Restrictions</div>
        <div class="row flex mt-3" *ngIf="this.allPrefer.cuisine != undefined">
            <div class="col-2 colDiv1 activeCol1 ml-1" *ngFor='let food of allPrefer.cuisine.foodRestrictions;let i=index;'>
                <div class="curisieSubTitle">{{food}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,4)">X</div>
                </div>
            </div>
        </div>
           
            <div class="col-12 mt-2">
                <div class="cross1Main" (click)="addPreference(4)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
            
       

        <div class="flex mt-4" *ngIf="isAddValue == 4">
            <input type="text" class="form-control textField textContent"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>

       
    </div>
</div>

<hr class="mt-5">

<div class="row mt-5">
    <div class="title">Lifestyle</div>
</div>

<div class="row mt-5">
    <div class="mealTitle">Cooking Time</div>
</div>

<div class="row">
    <div class="prepTimeContainer mt-3">
        <div class="prepTimeItem" *ngIf="selectedType[1] == 1">
            <div class="prepTimeLabel">Early morning Prep Time</div>
            <div>
                <input type="number" class="form-control textField1 textContent" [(ngModel)]="allPrefer.lifeStyle.emPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[2] == 1">
            <div class="prepTimeLabel">Breakfast Prep Time</div>
            <div>
                <input type="number" class="form-control textField1 textContent" [(ngModel)]="allPrefer.lifeStyle.bPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[3] == 1">
            <div class="prepTimeLabel">Mid morning Prep Time</div>
            <div>
                <input type="number" class="form-control textField1 textContent" [(ngModel)]="allPrefer.lifeStyle.mmPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[4] == 1">
            <div class="prepTimeLabel">Lunch Prep Time</div>
            <div>
                <input type="number" [(ngModel)]="allPrefer.lifeStyle.lPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0" class="form-control textField1 textContent"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[5] == 1">
            <div class="prepTimeLabel">Mid evening Prep Time</div>
            <div>
                <input type="number" [(ngModel)]="allPrefer.lifeStyle.mePrepTime" [ngModelOptions]="{standalone: true}" placeholder="0" class="form-control textField1 textContent"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[8] == 1">
            <div class="prepTimeLabel">Snack Prep Time</div>
            <div>
                <input type="number" [(ngModel)]="allPrefer.lifeStyle.sPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0" class="form-control textField1 textContent"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[6] == 1">
            <div class="prepTimeLabel">Dinner Prep Time</div>
            <div>
                <input type="number" [(ngModel)]="allPrefer.lifeStyle.dPrepTime" [ngModelOptions]="{standalone: true}" class="form-control textField1 textContent" placeholder="0"/>
            </div>
        </div>

        <div class="prepTimeItem" *ngIf="selectedType[7] == 1">
            <div class="prepTimeLabel">Bedtime Prep Time</div>
            <div>
                <input type="number" [(ngModel)]="allPrefer.lifeStyle.btPrepTime" [ngModelOptions]="{standalone: true}" placeholder="0" class="form-control textField1 textContent"/>
            </div>
        </div>
    </div>
</div>




<div class="row mt-5 flex">
    <div class="col-3">
        <div class="mealTitle">Kid Friendly</div>
    
        <div class="flex mt-4">
            <div class="col-4 colDiv1 " [ngClass]="{'activeCol1': isKidFriendly === 1}">
                <div class="curisieSubTitle">Yes</div>
                <div class="crossMain">
                <div class="cross" (click)="kidFriendly(1)"  *ngIf="isKidFriendly == 1">X</div>
                <div class="cross" (click)="kidFriendly(2)"  *ngIf="isKidFriendly == 2" >+</div>
                </div>
            </div>
            
        </div>
    </div>

    <div class="col-3">
        <div class="mealTitle">Meal Planning Friendly </div>
    
        <div class="flex mt-4">
            <div class="col-4 colDiv1"  [ngClass]="{'activeCol1': isPlanFriendly === 1}">
                <div class="curisieSubTitle" >Yes </div>
                <div class="crossMain">
                    <div class="cross" (click)="planFriendly(1)"  *ngIf="isPlanFriendly == 1">X</div>
                    <div class="cross" (click)="planFriendly(2)"  *ngIf="isPlanFriendly == 2" >+</div>
                </div>
            </div>
            <!-- <div class="col-4 ml-2 colDiv1" [ngClass]="{'activeCol1': allPrefer.lifeStyle.isMealPlanningFriendly === false}">
                <div class="curisieSubTitle">No</div>
                <div class="crossMain">
                <div class="cross">X</div>
                </div>
            </div> -->
        </div>
    </div>
    
    
</div>


<hr class="mt-5">

<div class="row mt-5">
    <div class="title">Allergies</div>
</div>

<div class="row mt-2">
    <div class="mealTitle">These are the food that are allergic to the member</div>
</div>

<div class="row mt-3">
    <div class="flex mt-4">
        <div class="col activeCol" *ngFor='let allegery of allPrefer.allergies;'>
            <div class="curisieSubTitle" *ngIf='allegery != ""'>{{allegery}}</div>           
        </div>

    </div>
</div>


<hr class="mt-5">

<div class="row mt-5">
    <div class="title">Ingredient Preference</div>
</div>

<!-- For Early morning -->
<div class="row mt-4" *ngIf="selectedType[1] == 1">
    <div class="col-md-12 ingredientTitle">For Early morning</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let Ingredient of allPrefer.likedIngredients.earlymorning;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,13)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(13)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 13">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.earlymorning;let i=index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,14)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(14)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 14">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Breakfast -->
<div class="row mt-4" *ngIf="selectedType[2] == 1">
    <div class="col-md-12 ingredientTitle">For Breakfast</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2"  *ngFor='let Ingredient of allPrefer.likedIngredients.breakfast;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,5)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(5)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 5">
            <input type="text" class="form-control textField textContent" style="width:30%"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.breakfast;let i =index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,6)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(6)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
            
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 6">
            <input type="text" class="form-control textField textContent" style="width:30%"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Mid morning -->
<div class="row mt-4" *ngIf="selectedType[3] == 1">
    <div class="col-md-12 ingredientTitle">For Mid morning</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let Ingredient of allPrefer.likedIngredients.midmorning;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,15)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(15)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 15">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.midmorning;let i=index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,16)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(16)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 16">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Lunch -->
<div class="row mt-4" *ngIf="selectedType[4] == 1">
    <div class="col-md-12 ingredientTitle">For Lunch</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2"  *ngFor='let Ingredient of allPrefer.likedIngredients.lunch;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,7)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(7)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 7">
            <input type="text" class="form-control textField textContent" style="width:30%"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.lunch;let i =index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,8)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(8)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
            
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 8">
            <input type="text" class="form-control textField textContent" style="width:30%"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Mid evening -->
<div class="row mt-4" *ngIf="selectedType[5] == 1">
    <div class="col-md-12 ingredientTitle">For Mid evening</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let Ingredient of allPrefer.likedIngredients.midevening;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,17)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(17)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 17">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.midevening;let i=index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,18)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(18)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 18">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Snack -->
<div class="row mt-4" *ngIf="selectedType[8] == 1">
    <div class="col-md-12 ingredientTitle">For Snack</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2"  *ngFor='let Ingredient of allPrefer.likedIngredients.snack;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,11)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(11)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 11">
            <input type="text" class="form-control textField textContent" style="width:30%"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.snack;let i =index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,12)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(12)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
            
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 12">
            <input type="text" class="form-control textField textContent" style="width:30%"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Dinner -->
<div class="row mt-4" *ngIf="selectedType[6] == 1">
    <div class="col-md-12 ingredientTitle">For Dinner</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2"  *ngFor='let Ingredient of allPrefer.likedIngredients.dinner;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,9)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(9)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 9">
            <input type="text" class="form-control textField textContent" style="width:30%"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.dinner;let i =index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,10)">X</div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(10)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                    </div>
            </div>
            
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 10">
            <input type="text" class="form-control textField textContent" style="width:30%"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>

<!-- For Bedtime -->
<div class="row mt-4" *ngIf="selectedType[7] == 1">
    <div class="col-md-12 ingredientTitle">For Bedtime</div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Liked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let Ingredient of allPrefer.likedIngredients.bedtime;let i=index;'>
                <div class="curisieSubTitle">{{Ingredient}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,19)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(19)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 19">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
    <div class="col-sm mt-3">
        <div class="mealTitle">Disliked Ingredients</div>
        <div class="col-md-12 mt-3">
            <div class="col-4 ml-1 mt-2 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients.bedtime;let i=index'>
                <div class="curisieSubTitle">{{dislike}}</div>
                <div class="crossMain">
                <div class="cross" (click)="removePreference(i,20)">X</div>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <div class="cross1Main" (click)="addPreference(20)">
                    <div class="cross2Sub">
                    <div class="cross1">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 20">
            <input type="text" class="form-control textField textContent" style="width:30%" [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
    </div>
</div>
<!-- <div class="row mt-4">
    
</div> -->
<!-- 
<div class="row mt-3">
    
        <div class="col-2 ml-1 activeCol2"  *ngFor='let Ingredient of allPrefer.likedIngredients;let i=index;'>
            <div class="curisieSubTitle">{{Ingredient}}</div>
            <div class="crossMain">
            <div class="cross" (click)="removePreference(i,5)">X</div>
            </div>
        </div>

       


        <div class="col-2">
            <div class="cross1Main" (click)="addPreference(5)">
                <div class="cross2Sub">
                <div class="cross1">+</div>
                </div>
                </div>
        </div>

        <div class="col-12 flex mt-4" *ngIf="isAddValue == 5">
            <input type="text" class="form-control textField textContent" style="width:30%"   [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>
       
    </div>


    <div class="row mt-4">
        <div class="mealTitle">Disliked Ingredients</div>
    </div>
    <div class="row mt-3">
        
        <div class="col-2 ml-1 activeCol2" *ngFor='let dislike of allPrefer.dislikedIngredients;let i =index'>
            <div class="curisieSubTitle">{{dislike}}</div>
            <div class="crossMain">
            <div class="cross" (click)="removePreference(i,6)">X</div>
            </div>
        </div>

      

        <div class="col-2">
            <div class="cross1Main" (click)="addPreference(6)">
                <div class="cross2Sub">
                <div class="cross1">+</div>
                </div>
                </div>
        </div>
        
        <div class="col-12 flex mt-4" *ngIf="isAddValue == 6">
            <input type="text" class="form-control textField textContent" style="width:30%"  [(ngModel)]="preferValue" [ngModelOptions]="{standalone: true}" placeholder="Enter Value"/> &nbsp;&nbsp; <button type="button" (click)="savePreference()" class="btn btnClass">Save</button> 
        </div>

    </div> -->

